import { useEffect, useState } from 'react';

/**
 * React 컴포넌트가 아닌 실제 dom 이 존재하는 지 확인하는 hook
 * 해당 dom 이 존재하지 않거나, 존재하지 않게 되면 상태가 false 로 변경된다.
 * @param dom
 */
export const useDomExist = (dom: HTMLElement | null) => {
  const [isExist, setIsExist] = useState(!!dom);
  useEffect(() => {
    if (!dom) {
      setIsExist(false);

      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.removedNodes.length > 0 && !document.contains(dom)) {
          setIsExist(false);
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  return isExist;
};
